export const DISTRICT_MAPPING_FILTER = 'district_mapping_id';
export const COMPETITOR_FILTER = 'competitor_id';
export const DISPLAY_AGENCY_NAME_FILTER = 'display_agency_name';
export const TYPE_FILTER = 'type';

export function getCompetitorDisplayName(row: {
    competitor_mapped?: string | null;
    agency_name?: string | null;
}): string | null {
    const mapped = row.competitor_mapped?.trim();
    if (mapped) {
        return mapped;
    }

    const raw = row.agency_name?.trim();
    return raw || null;
}

export function applyDisplayAgencyNameToQuery(
    params: Record<string, any>,
    displayAgencyName: string
): Record<string, any> {
    return {
        ...params,
        [`filter[${DISPLAY_AGENCY_NAME_FILTER}][type]`]: 'select',
        [`filter[${DISPLAY_AGENCY_NAME_FILTER}][value]`]: displayAgencyName,
    };
}

export function applyDisplayAgencyNameToFilterObject(
    params: Record<string, any>,
    displayAgencyName: string
): Record<string, any> {
    return {
        ...params,
        filter: {
            ...(params['filter'] ?? {}),
            [DISPLAY_AGENCY_NAME_FILTER]: {
                ...(params['filter']?.[DISPLAY_AGENCY_NAME_FILTER] ?? {}),
                type: 'select',
                value: displayAgencyName,
            },
        },
    };
}

export function applyDistrictAndCompetitorToQuery(
    params: Record<string, any>,
    options: {
        districtMappingId?: string | null;
        competitorId?: string | null;
        type?: string | null;
    }
): Record<string, any> {
    const next = { ...params };

    if (options.districtMappingId) {
        next[`filter[${DISTRICT_MAPPING_FILTER}][value]`] = options.districtMappingId;
    }

    if (options.competitorId) {
        next[`filter[${COMPETITOR_FILTER}][value]`] = options.competitorId;
    }

    if (options.type) {
        next[`filter[${TYPE_FILTER}][value]`] = options.type;
    }

    return next;
}

export function applyDistrictAndCompetitorToFilterObject(
    params: Record<string, any>,
    options: {
        districtMappingId?: string | null;
        competitorId?: string | null;
        type?: string | null;
    }
): Record<string, any> {
    if (!options.districtMappingId && !options.competitorId && !options.type) {
        return params;
    }

    return {
        ...params,
        filter: {
            ...(params['filter'] ?? {}),
            ...(options.districtMappingId && {
                [DISTRICT_MAPPING_FILTER]: {
                    ...(params['filter']?.[DISTRICT_MAPPING_FILTER] ?? {}),
                    value: options.districtMappingId,
                },
            }),
            ...(options.competitorId && {
                [COMPETITOR_FILTER]: {
                    ...(params['filter']?.[COMPETITOR_FILTER] ?? {}),
                    value: options.competitorId,
                },
            }),
            ...(options.type && {
                [TYPE_FILTER]: {
                    ...(params['filter']?.[TYPE_FILTER] ?? {}),
                    value: options.type,
                },
            }),
        },
    };
}
